export type Language = 'en' | 'fr' | 'es';

export function useLanguage(): Language {
  const language = window.pplsi?.market as string | undefined;
  return (language?.slice(0, 2) as Language) || 'en';
}
